import { apiClient } from "../clientApi";
import { useMutation } from "@tanstack/react-query";
import type { DefaultError } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

export interface SurveyAnswerPayload {
  id: string; // question id
  selectedAnswerIndex?: number | number[] | null; // for choice questions
  answer?: string | null; // for open-ended
  answerDuration?: number; // seconds spent on this question
}

export interface PostSurveyResultRequest {
  survey_id: number;
  duration: number; // total duration in seconds
  survey_result: SurveyAnswerPayload[];
}

export interface PostSurveyResultResponse {
  success: boolean;
  surveyResult: any; // can type with Prisma model if needed
}

export const useSubmitSurvey = ({
  onSuccess,
  onFail,
}: {
  onSuccess?: (data: PostSurveyResultResponse, variables: PostSurveyResultRequest, context: any) => void;
  onFail?: (error: any, variables: PostSurveyResultRequest, context: any) => void;
}) =>
  useMutation<PostSurveyResultResponse, DefaultError, PostSurveyResultRequest>({
    mutationFn: async (form) => {
      const { data } = await apiClient.post<
        PostSurveyResultResponse,
        AxiosResponse<PostSurveyResultResponse>,
        PostSurveyResultRequest
      >(`/user-surveys/`, form);

      return data;
    },
    onSuccess,
    onError: onFail,
  });
